import React, { useState } from 'react';
import { RestHelperNoAuth } from "../helper/restHelperNoAuth";
import { Link } from 'react-router-dom'
import mixpanel from "mixpanel-browser";

const TitleHero = () => {
      const [showForm1, setShowForm1] = useState(false);
      const [showForm2, setShowForm2] = useState(false);
      const [formTitle, setFormTitle] = useState('Ready To Streamline Your Processes')
      const [formComments, setFormComments] = useState('Company Name')
      const [formCommentsDescription, setFormCommentsDescription] = useState('Name of Title Company')
      const [apiRes, setApiRes] = useState('')
      const [showResponse, setShowResponse] = useState(false)
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        comments: '',
        subject: ''
      });



    const handleResponse = (e) => {
        setApiRes(e)
        setShowResponse(true)
        setFormData({
            ...formData,
            ['name']: '',
            ['email']: '',
            ['phone']: '',
            ['comments']: '',
            ['subject']: ''
        })
      }
      const handleShowForm = (param, param2) => {
        if (param === 'notary'){
          setFormTitle('Notary Request Form')
          setFormComments('Notarization Needs')
          setFormCommentsDescription('Please describe what you need notarized')
          mixpanel.track('Title Landing Page', {'action' : 'Show Notary Contact Us Form'})
        }
        else {
          setFormTitle('Ready To Streamline Your Processes?')
          setFormComments('Company Name')
          setFormCommentsDescription('Name of Title Company')
          mixpanel.track('Title Landing Page', {'action' : 'Show Title Company Contact Us Form'})
        }
    
        if (param2 === '1'){
            setShowForm1(true);
        }
        else{
            setShowForm2(true)
        }
        
      }
      //const handleCloseForm = () => setShowForm(false);
      const [error, setError] = useState('');
      const api = RestHelperNoAuth()
    
        // Handle form input changes
        const handleChange = (e) => {
            setFormData({
              ...formData,
              [e.target.name]: e.target.value,
            });
          };
    
      // Function to handle form submission
      const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent page reload on form submission
    
        // Simple validation example (you can add more specific checks if needed)
        if (!formData.name || !formData.email || !formData.phone || ! formData.comments) {
          setError('Please fill in all required fields');
          return;
        }
        mixpanel.track('Title Landing Page', {'action' : 'SubmitRequest'})
        try {
          // Send data to your API using fetch
          callApi()
           // Trigger Google Ads conversion event
          window.gtag('event', 'conversion', {
          'send_to': 'AW-1023542218/irtdCKSJ0YMaEMqHiOgD',
          'value': 1.0,
          'currency': 'USD',
        });
        } catch (error) {
          // Handle network errors
          setError('There was an error submitting your request. Please try again later.');
        }
      };
    
      const callApi = () => {
        const options = {}
        setShowForm1(false)
        setShowForm2(false)
        api
        .postCreate('/create-contact-request', options, formData)
        .then(res => handleResponse(res))
        .catch(err => console.log(err))
    }
  
    return (
      <div className="landing-page">
        {/* Custom CSS */}
        <style>
          {`
            /* Base Styles from Provided CSS */
            .landing-page {
              font-family: Arial, sans-serif;
              color: #333;
              margin: 0;
              padding: 0;
            }
            
            .nav-link {
              color: #353535;
            }
            
            .nav-link:hover {
              color: gray;
            }
            
            .navbar .router-link-exact-active {
              color: #041433;
              border-bottom: 3px solid #212121;
            }
            
            /* Hero Section */
            .hero-section {
              position: relative;
              text-align: center;
              background-color: #333;
              color: white;
              padding: 40px 20px;
              border-radius: 8px;
            }
            
            .hero-content {
              z-index: 1;
              position: relative;
            }
            
            .hero-section h1 {
              font-size: 2.5em;
              color: #00bfff;
            }
            
            .hero-section p {
              font-size: 1.2em;
            }
            
            .cta-button {
              background-color: #00bfff;
              color: white;
              padding: 10px 20px;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              font-size: 1.2em;
              margin-top: 20px;
            }
            
            .cta-button:hover {
              background-color: #007acc;
            }
            
            /* Info and Testimonials Sections */
            .info-section, .testimonials-section, .reviews-section {
              background-color: #f4f4f4;
              color: #333;
              padding: 40px 20px;
              text-align: center;
            }
            
            .info-section h2, .testimonials-section h2, .reviews-section h2 {
              font-size: 2em;
              margin-bottom: 20px;
            }
            
            .info-section p {
              font-size: 1.1em;
              max-width: 800px;
              margin: 0 auto;
            }
            
            /* Badge Pills Styling */
            .benefit-tag {
              background-color: rgba(0, 191, 255, 0.1);
              color: #00bfff;
              border-radius: 50px;
              padding: 0.5rem 1rem;
              font-weight: 500;
              margin: 5px;
              display: inline-block;
            }
            
            /* Stats Section */
            .stats-section {
              background-color: white;
              padding: 30px 20px;
            }
            
            .stat-card h3 {
              font-size: 2.5rem;
              color: #00bfff;
              margin-bottom: 0.5rem;
            }
            
            .stat-card p {
              color: #555;
              font-size: 1.125rem;
            }
            
            /* Features Section */
            .features-section {
              padding: 30px 20px;
              background-color: white;
            }
            
            .feature-card {
              background-color: white;
              border-radius: 8px;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
              padding: 2rem;
              text-align: center;
              transition: transform 0.3s ease, box-shadow 0.3s ease;
              margin-bottom: 2rem;
            }
            
            .feature-card:hover {
              transform: translateY(-5px);
              box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
            }
            
            .feature-icon {
              width: 64px;
              height: 64px;
              background-color: #f0f7ff;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto 1.5rem;
              font-size: 1.5rem;
            }
            
            /* Process Section */
            .process-section {
              padding: 40px 20px;
              background-color: #f4f4f4;
            }
            
            .process-step {
              display: flex;
              margin-bottom: 2rem;
            }
            
            .step-number {
              flex-shrink: 0;
              width: 48px;
              height: 48px;
              border-radius: 50%;
              background-color: #00bfff;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 1.25rem;
              margin-right: 1.5rem;
            }
            
            /* Highlight Box */
            .highlight-box {
              background-color: rgba(0, 191, 255, 0.05);
              border-left: 4px solid #00bfff;
              padding: 1.5rem;
              border-radius: 0 0.5rem 0.5rem 0;
              margin: 2rem 0;
            }
            
            .highlight-box h3 {
              color: #00bfff;
              margin-bottom: 0.5rem;
            }
            
            /* Testimonials */
            .testimonial-card {
              background-color: white;
              border-radius: 8px;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
              padding: 2rem;
              margin-bottom: 2rem;
            }
            
            .testimonial-content {
              font-style: italic;
              margin-bottom: 1.5rem;
              color: #555;
            }
            
            .testimonial-author {
              display: flex;
              align-items: center;
            }
            
            .author-avatar {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              background-color:rgb(88, 87, 87);
              margin-right: 1rem;
            }
            
            /* Form Styling */
            .form-container {
              position: relative;
              background-color: #f0f0f0;
              padding: 20px;
              margin-top: 20px;
              border-radius: 8px;
              max-width: 600px;
              margin-left: auto;
              margin-right: auto;
            }
            
            .form-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
            }
            
            .close-button {
              background: transparent;
              border: none;
              font-size: 1.5em;
              cursor: pointer;
              color: #333;
            }
            
            .appraisal-form label {
              display: block;
              margin-bottom: 5px;
              text-align: left;
              font-weight: bold;
            }
            
            .appraisal-form input,
            .appraisal-form textarea {
              width: 100%;
              padding: 10px;
              margin-bottom: 15px;
              border-radius: 4px;
              border: 1px solid #ccc;
            }
            
            .submit-button {
              background-color: #00bfff;
              color: white;
              padding: 10px 20px;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              font-size: 1.2em;
            }
            
            .submit-button:hover {
              background-color: #007acc;
            }
            
            /* Footer */
            footer {
              background-color: #333;
              color: white;
              text-align: center;
              padding: 20px;
            }
            
            /* Phone Link */
            a.phone-link {
              color: #00bcd4;
              font-weight: bold;
              text-decoration: none;
            }
            
            a.phone-link:hover {
              text-decoration: underline;
            }
            
            /* Responsive Styles */
            @media (max-width: 768px) {
              .hero-section h1 {
                font-size: 2rem;
              }
              
              .process-step {
                flex-direction: column;
                text-align: center;
              }
              
              .step-number {
                margin: 0 auto 1rem;
              }
              
              .testimonial-author {
                flex-direction: column;
                text-align: center;
              }
              
              .author-avatar {
                margin: 0 auto 1rem;
              }
            }
          `}
        </style>

  
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1><i>Streamline Your Closing Process with Pinpoint Field Services</i></h1>
              <p>Trusted by leading title companies and escrow officers nationwide. We handle the notary logistics so you can focus on your closings.</p>
              
              <div className="d-flex flex-wrap justify-content-center mt-4 mb-4">
                <span className="benefit-tag">Nationwide Coverage</span>
                <span className="benefit-tag">24-Hour Turnaround</span>
                <span className="benefit-tag">Dedicated Account Manager</span>
                <span className="benefit-tag">Verified Professionals</span>
                <span className="benefit-tag">Competitive Pricing</span>
              </div>
              
              <button className="cta-button" onClick={(e) => {handleShowForm('notary', '1')}}>Schedule Your Notary Today</button>
            </div>
          </div>
        </section>

              {/* Form section (shows when CTA is clicked) */}

        {showResponse &&
        <div className="info-section">
            <p>{apiRes}</p>
        </div>
      }
      {showForm1 && (
        <div className="form-container">
          <div className="form-header">
            <h2>{formTitle}</h2>
            {/* X button to close the form */}
            <button className="close-button" onClick={() => setShowForm1(false)}>X</button>
          </div>
          <form className="appraisal-form" onSubmit={handleSubmit}>
            <h6>Thanks for your interest, please fill out the below form or give us a call at <a href="tel:888-530-7592" className='phone-link'>888-530-7592</a>.  We'll be in touch soon!</h6>
            <br/>
            <label>Name:</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
            
            <label>Email Address:</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />
            
            <label>Callback Number:</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your Phone Number" required />
            
            <label>{formComments}:</label>
            <textarea name="comments" value={formData.comments} onChange={handleChange} placeholder={formCommentsDescription} />
            
            <label>City, State:</label>
            <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="City, State" />
            
            {/* Display error message if validation fails */}
            {error && <p className="error-message">{error}</p>}
            
            <button type="submit" className="submit-button">Submit</button>
          </form>
        </div>
      )}
  
        {/* Stats Section */}
        <section className="stats-section">
          <div className="container">
            <div className="row text-center">
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>★★★★★</h3>
                <p>Google Reviews Rating</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>20+</h3>
                <p>Years of Industry Experience</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>50</h3>
                <p>States Covered</p>
              </div>
              <div className="col-md-3 col-sm-6 mb-4 stat-card">
                <h3>8,000+</h3>
                <p>Verified Notaries</p>
              </div>
              
            </div>
          </div>

        </section>
  
        {/* Features Section */}
        <section className="features-section">
          <div className="container">
      <div className="text-center mb-4">
          <img
                  src={window.innerWidth < 768 ? "/img/pinpoint-closing-secondary.jpg" : "/img/pinpoint-closing-secondary.jpg"}
                  alt="Real Estate closing"
                  className="img-fluid" 
                  style={{ 
                    maxWidth: '600px', 
                    width: '100%', 
                    borderRadius: '8px', 
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)' 
                  }} 
              />
            </div>
            <div className="text-center mb-5">
              <h2>Specialized Notary Services for Title & Escrow</h2>
              <p className="mb-5">We understand the unique needs of title companies and escrow offices when it comes to document signings.</p>
            </div>
            
            <div className="row">
              {/* Feature 1 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">📝</div>
                  <h3>Loan Closings</h3>
                  <p>Our notaries are experienced with mortgage loan documents and follow your specific instructions to ensure a smooth closing experience for all parties.</p>
                </div>
              </div>
              
              {/* Feature 2 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">⏱️</div>
                  <h3>Rush Signings</h3>
                  <p>Need a notary on short notice? Our expedited service can connect you with a qualified professional within hours, not days.</p>
                </div>
              </div>
              
              {/* Feature 3 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">🏠</div>
                  <h3>Remote Locations</h3>
                  <p>We specialize in reaching signers in rural and hard-to-serve areas where many services don't have coverage.</p>
                </div>
              </div>
              
              {/* Feature 4 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">📲</div>
                  <h3>Real-Time Updates</h3>
                  <p>Stay informed with automated notifications at every stage of the signing process from scheduling to document return.</p>
                </div>
              </div>
              
              {/* Feature 5 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                <div className="feature-icon">✉️</div>
                  <h3>Message Center</h3>
                  <p>Secure messaging portal to track all communications for your order, including secured access for your escrow team to cover orders across the team.</p>
                </div>
              </div>
              
              {/* Feature 6 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-card h-100">
                  <div className="feature-icon">🔄</div>
                  <h3>Document Tracking</h3>
                  <p>Our secure system tracks all documents from printing to return shipping, ensuring nothing gets lost in the process.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
  
  
        {/* Process Section */}
        <section className="process-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2>A Seamless Process Designed for Title Companies</h2>
              <p className="mb-4">We've streamlined every step to make working with us effortless.</p>
            </div>
            
            <div className="mx-auto" style={{ maxWidth: '800px' }}>
              {/* Step 1 */}
              <div className="process-step">
                <div className="step-number">1</div>
                <div>
                  <h4>Submit Your Request</h4>
                  <p>Use our online portal, email, or call your dedicated account manager with the signing details. We'll confirm receipt within minutes.</p>
                </div>
              </div>
              
              {/* Step 2 */}
              <div className="process-step">
                <div className="step-number">2</div>
                <div>
                  <h4>We Handle Scheduling</h4>
                  <p>Our team contacts the signers, arranges a convenient time, and confirms the appointment with all parties.</p>
                </div>
              </div>
              
              {/* Step 3 */}
              <div className="process-step">
                <div className="step-number">3</div>
                <div>
                  <h4>Professional Signing Agent Assigned</h4>
                  <p>We match your signing with a vetted, experienced notary who specializes in real estate transactions.</p>
                </div>
              </div>
              
              {/* Step 4 */}
              <div className="process-step">
                <div className="step-number">4</div>
                <div>
                  <h4>Signing Completed</h4>
                  <p>The notary executes the signing according to your instructions and provides immediate confirmation upon completion.</p>
                </div>
              </div>
              
              {/* Step 5 */}
              <div className="process-step">
                <div className="step-number">5</div>
                <div>
                  <h4>Secure Document Return</h4>
                  <p>Documents are returned via your preferred method—overnight shipping, secure upload, or courier service.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
  
        {/* Testimonials */}
        <section className="testimonials-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2>Trusted by Title Companies Nationwide</h2>
              <p>Don't just take our word for it. Here's what our clients have to say.</p>
            </div>
            
            <div className="row">
              {/* Testimonial 1 */}
              <div className="col-lg-6 col-md-6">
                <div className="testimonial-card">
                  <p className="testimonial-content">"As a settlement agent who works with several different mobile notary companies, I have to say Pinpoint is TOP NOTCH! Michael and his team are quick, reliable and I never have to worry about a lack of experience. The process and systems for Pinpoint are so user friendly and makes my job that much easier!"</p>
                  <div className="testimonial-author">
                    <div className="author-avatar"></div>
                    <div>
                      <h5>Settlement Agent in Nebraska</h5>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Testimonial 2 */}
              <div className="col-lg-6 col-md-6">
                <div className="testimonial-card">
                  <p className="testimonial-content">"Pinpoint Field Services offers not only professional and prompt service as a course of regular business, but has also stepped in and gone above and beyond to get things done when needed. This level of support helps everyone involved achieve a common goal and they understand how valuable that is. I trust them wholly to be that valued partner that helps me do my job better."</p>
                  <div className="testimonial-author">
                    <div className="author-avatar"></div>
                    <div>
                      <h5>Title Company in Nebraska</h5>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </section>

        
      {/* Google Reviews Section */}
      <section className="reviews-section">
        <h2>Google Reviews</h2>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Fantastic service to work with! Great communication and integrity!" - Barbara B.</p>
        </div>
        <hr/>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Love this company, they are very conscientious and do what they say they will do. I would work with them any day." - Janet S.</p>
        </div>
        <hr/>
        <div className="google-reviews col">
          {/* Placeholder for embedding Google Reviews */}
          <p>★★★★★</p>
          <p>"Thank you for the opportunity to work with you and your company. The experience was exceptional, and the professionalism was top-notch throughout the process. Highly recommend!" - Krishanna F.</p>
        </div>
        <button className="cta-button" onClick={handleShowForm}>Learn More</button>
      </section>
  
        {/* CTA Section / Contact */}
        <section id="contact" className="hero-section">
          <div className="container">
            <h2>Ready to Simplify Your Closing Process?</h2>
            <p className="mb-4">Schedule a consultation with our team to discuss your notary service needs and learn how we can support your title company's success.</p>
            <button className="cta-button" onClick={(e) => {handleShowForm('default', '2')}}>Schedule a Consultation</button>
            <p className="mt-3">Or call us directly: <a href="tel:8885307592" className="phone-link">(888) 530-7592</a></p>
          </div>
        </section>
  
        {/* Form Popup */}

        {showResponse &&
        <div className="info-section">
            <p>{apiRes}</p>
        </div>
      }

        {showForm2 && (
        <div className="form-container">
          <div className="form-header">
            <h2>{formTitle}</h2>
            {/* X button to close the form */}
            <button className="close-button" onClick={() => setShowForm2(false)}>X</button>
          </div>
          <form className="appraisal-form" onSubmit={handleSubmit}>
            <h6>Thanks for your interest, please fill out the below form or give us a call at <a href="tel:888-530-7592" className='phone-link'>888-530-7592</a>.  We'll be in touch soon!</h6>
            <br/>
            <label>Name:</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
            
            <label>Email Address:</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />
            
            <label>Callback Number:</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your Phone Number" required />
            
            <label>{formComments}:</label>
            <textarea name="comments" value={formData.comments} onChange={handleChange} placeholder={formCommentsDescription} />
            
            <label>City, State:</label>
            <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="City, State" />
            
            {/* Display error message if validation fails */}
            {error && <p className="error-message">{error}</p>}
            
            <button type="submit" className="submit-button">Submit</button>
          </form>
        </div>
      )}
  
      </div>
    );
  };

export default TitleHero;